module.exports = __webpack_public_path__ + "static/gemfinance-banner-e72e41a1b746bb8560c2249f22c6d03d.webp";